import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "./export-buttons.module.scss";
import Button from "../../../../ui-kit/button/button";
import { getKrookieDoc } from "../../../../../services/api";
import {
  filterBySubstring,
  TableFilters,
} from "../../../../../utils/filters-for-table";
import { TableData } from "../../../../../types/table-filter-types";
import { formatTableTime } from "../../../../../utils/format-table-dates";
import { ExportToExcel } from "../../../../../utils/export-to-excel";

interface ExportButtonsProps {
  selected: number[];
  dataSource: TableData;
  filters: TableFilters;
  currentPage: number;
  substringFields: string[];
}

const ExportButtons: FC<ExportButtonsProps> = ({
  selected,
  filters,
  dataSource,
  currentPage,
  substringFields,
}) => {
  const exportToExcel = () => {
    let idx = 1;
    const customSheet = filterBySubstring(
      dataSource,
      filters,
      currentPage,
      0,
      substringFields,
    )
      .filter(
        (krookie) => selected.length === 0 || selected.includes(krookie.id),
      )
      .map((krookie) => ({
        [t("export-buttons.excelColumns.no")]: idx++,
        [t("export-buttons.excelColumns.plotNumber")]: krookie.newPlotNum,
        [t("export-buttons.excelColumns.krookieStatus")]: krookie.status,
        [t("export-buttons.excelColumns.industrialCity")]: krookie.city,
        [t("export-buttons.excelColumns.address")]: krookie.streetNum,
        [t("export-buttons.excelColumns.landStatus")]: "",
        [t("export-buttons.excelColumns.plotArea")]: krookie.area,
        [t("export-buttons.excelColumns.formationDate")]: formatTableTime(
          new Date(krookie.changedDateTime),
          "MM/DD/YYYY",
        ),
        [t("export-buttons.excelColumns.drafter")]: krookie.userName,
        [t("export-buttons.excelColumns.landUse")]: krookie.landUse,
        [t("export-buttons.excelColumns.tenant")]: "",
      }));

    const columns = {
      [t("export-buttons.excelColumns.no")]: 6,
      [t("export-buttons.excelColumns.plotNumber")]: 19,
      [t("export-buttons.excelColumns.krookieStatus")]: 17,
      [t("export-buttons.excelColumns.industrialCity")]: 28,
      [t("export-buttons.excelColumns.address")]: 35,
      [t("export-buttons.excelColumns.landStatus")]: 17,
      [t("export-buttons.excelColumns.plotArea")]: 13,
      [t("export-buttons.excelColumns.formationDate")]: 22,
      [t("export-buttons.excelColumns.drafter")]: 20,
      [t("export-buttons.excelColumns.landUse")]: 15,
      [t("export-buttons.excelColumns.tenant")]: 27,
    };
    ExportToExcel(
      columns,
      customSheet,
      t("export-buttons.excelSheetName"),
      t("export-buttons.excelFileName"),
    );
  };

  const { t } = useTranslation();
  return (
    <div className={styles.exportBtns}>
      <Button
        className={styles.excel}
        type="withIcon"
        onClick={() => exportToExcel()}
      >
        <span>{t("export-buttons.exportExcel")}</span>
      </Button>
      <Button
        className={styles.print}
        type="withIcon"
        disabled={selected.length == 0}
        onClick={() => getKrookieDoc(selected)}
      >
        <span>{t("export-buttons.printKrookies")}</span>
      </Button>
    </div>
  );
};

export default ExportButtons;
